module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/costume_02-72da51d13037d4202d8a85f54c0b2023.webp";